import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMembers, removeMember, createMember, setMemberModules } from '../../store/actions/tenant';
import { Button, Table, Form, Row, Col } from 'react-bootstrap';
import { MODULES, MODULE_KEYS } from '../../config/modules';

const emptyForm = { name: '', surname: '', email: '', username: '', contact: '', modules: [] };

const hasModule = (member, key) => member.modules === 'all' || member.modules.includes(key);

const TenantMembers = () => {
    const dispatch = useDispatch();
    const members = useSelector(state => state.tenant.members);
    const licensedModules = useSelector(state => state.tenant.licensedModules);
    const currentUserId = useSelector(state => state.users.data?._id);
    const isOwner = useSelector(state => state.users.data?.isOwner);
    const [form, setForm] = useState(emptyForm);

    const availableModuleKeys = MODULE_KEYS.filter(key => licensedModules.includes(key));

    useEffect(() => {
        dispatch(fetchMembers());
    }, [dispatch]);

    const handleRemove = (userId) => {
        if (window.confirm('Naozaj chceš odobrať prístup tomuto používateľovi?')) {
            dispatch(removeMember(userId));
        }
    };

    const toggleFormModule = (key) => {
        setForm(f => ({
            ...f,
            modules: f.modules.includes(key) ? f.modules.filter(m => m !== key) : [...f.modules, key]
        }));
    };

    const handleCreate = async (e) => {
        e.preventDefault();
        const result = await dispatch(createMember(form));
        if (!result.error) {
            setForm(emptyForm);
        }
    };

    const toggleMemberModule = (member, key) => {
        const current = availableModuleKeys.filter(k => hasModule(member, k));
        const next = current.includes(key) ? current.filter(k => k !== key) : [...current, key];
        dispatch(setMemberModules({ userId: member._id, modules: next }));
    };

    return (
        <div>
            {isOwner && (
                <div className="mb-4">
                    <h5 className="mb-3">Vytvoriť používateľa</h5>
                    <Form onSubmit={handleCreate}>
                        <Row className="g-2 align-items-end">
                            <Col md={2}>
                                <Form.Control
                                    placeholder="Meno"
                                    value={form.name}
                                    onChange={e => setForm({ ...form, name: e.target.value })}
                                    required
                                />
                            </Col>
                            <Col md={2}>
                                <Form.Control
                                    placeholder="Priezvisko"
                                    value={form.surname}
                                    onChange={e => setForm({ ...form, surname: e.target.value })}
                                    required
                                />
                            </Col>
                            <Col md={3}>
                                <Form.Control
                                    type="email"
                                    placeholder="Email"
                                    value={form.email}
                                    onChange={e => setForm({ ...form, email: e.target.value })}
                                    required
                                />
                            </Col>
                            <Col md={2}>
                                <Form.Control
                                    placeholder="Prihlasovacie meno"
                                    value={form.username}
                                    onChange={e => setForm({ ...form, username: e.target.value })}
                                    minLength={3}
                                    maxLength={15}
                                    required
                                />
                            </Col>
                            <Col md={3}>
                                <Form.Control
                                    placeholder="+421910123456"
                                    value={form.contact}
                                    onChange={e => setForm({ ...form, contact: e.target.value })}
                                    required
                                />
                            </Col>
                        </Row>
                        <Row className="mt-2 align-items-center">
                            <Col md={9}>
                                {availableModuleKeys.map(key => (
                                    <Form.Check
                                        inline
                                        key={key}
                                        type="checkbox"
                                        id={`new-module-${key}`}
                                        label={MODULES[key]}
                                        checked={form.modules.includes(key)}
                                        onChange={() => toggleFormModule(key)}
                                    />
                                ))}
                            </Col>
                            <Col md={3}>
                                <Button type="submit" variant="primary" className="w-100">
                                    Vytvoriť
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </div>
            )}

            <h5 className="mb-3">Členovia subjektu</h5>
            {members.length === 0 ? (
                <p className="text-muted">Žiadni členovia.</p>
            ) : (
                <Table hover>
                    <thead>
                        <tr>
                            <th>Meno</th>
                            <th>Email</th>
                            <th>Prístup k modulom</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {members.map(member => (
                            <tr key={member._id}>
                                <td>
                                    {member.name} {member.surname}
                                    {member.isOwner && (
                                        <span className="badge bg-secondary ms-2" style={{ fontSize: '10px' }}>owner</span>
                                    )}
                                </td>
                                <td className="text-muted">{member.email}</td>
                                <td>
                                    {member.isOwner ? (
                                        <span className="text-muted">Všetky moduly</span>
                                    ) : (
                                        availableModuleKeys.map(key => (
                                            <Form.Check
                                                inline
                                                key={key}
                                                type="checkbox"
                                                id={`member-${member._id}-${key}`}
                                                label={MODULES[key]}
                                                checked={hasModule(member, key)}
                                                disabled={!isOwner}
                                                onChange={() => toggleMemberModule(member, key)}
                                            />
                                        ))
                                    )}
                                </td>
                                <td className="text-end">
                                    {isOwner && member._id !== currentUserId && !member.isOwner && (
                                        <Button
                                            size="sm"
                                            variant="outline-danger"
                                            onClick={() => handleRemove(member._id)}
                                        >
                                            Odobrať prístup
                                        </Button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </div>
    );
};

export default TenantMembers;
